import { render, staticRenderFns } from "./tableItems.vue?vue&type=template&id=d88b1dba&scoped=true"
import script from "./tableItems.vue?vue&type=script&lang=js"
export * from "./tableItems.vue?vue&type=script&lang=js"
import style0 from "./tableItems.vue?vue&type=style&index=0&id=d88b1dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88b1dba",
  null
  
)

export default component.exports